import { clearUserSession } from "./CommonFunction";

const baseUrl: string | undefined = process.env.REACT_APP_BASE_URL;

console.log(global.authToken, "global.authToken");

const newBaseUrl = () => {
  if (window.location.protocol === "http:") {
    let newBaseUrl: string | undefined = baseUrl;
    newBaseUrl = newBaseUrl?.replace("https", "http");
    return newBaseUrl;
  } else {
    return baseUrl;
  }
};

export const fetchApiGet = async (token: string | null, endPoint: string) => {
  try {
    console.log("global.authToken", global.authToken);
    let response = await fetch(`${newBaseUrl()}${endPoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? "Bearer " + token : "",
        sessionId: global.authToken,
      },
    });
    let jsonResponse = await response.json();
    return jsonResponse;
  } catch (error) {
    if (error instanceof Error && (error as any).response?.status == 401) {
      clearUserSession();
    }
    throw error;
  }
};

export const fetchApiPost = async (
  token: string | null,
  endPoint: string,
  data: any,
) => {
  try {
    let response = await fetch(`${newBaseUrl()}${endPoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? "Bearer " + token : "",
        sessionid: global.authToken,
      },
      body: JSON.stringify(data),
    });
    let jsonResponse = await response.json();
    return jsonResponse;
  } catch (error) {
    if (error instanceof Error && (error as any).response?.status == 401) {
      clearUserSession();
    }
    throw error;
  }
};

export const fetchJcApiPost = async (endpoint: string, data: any) => {
  try {
    const res = await fetch(`http://jobup.mobi/jcms/${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-auth": "0vyM47sd4320gfg41v9R6",
      },
      body: JSON.stringify(data),
    });
    const response = await res.json();
    return response;
  } catch (error) {
    throw error;
  }
};
export const fetchJcApiGet = async (endpoint: string) => {
  try {
    const res = await fetch(`http://jobup.mobi/jcms/${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-auth": "0vyM47sd4320gfg41v9R6",
      },
    });
    const response = await res.json();
    return response;
  } catch (error) {
    throw error;
  }
};
